/**
 * The API answers in two shapes: Laravel validation (`{message, errors}`) and
 * the domain envelope (`{title, description, error_code}`). Callers that only
 * knew one of them showed a blank alert for the other, which is why three
 * near-copies of this had drifted apart across the partner screens.
 */
export function firstApiError(response) {
  const validation = response?.errors ? Object.values(response.errors).flat() : [];

  return validation[0] ?? response?.description ?? response?.message ?? response?.title ?? null;
}

/**
 * Every validation message, in order and once each, for a form that can fail on more than one field
 * at a time; the domain envelope's single message otherwise.
 */
export function allApiErrors(response) {
  const validation = response?.errors ? [...new Set(Object.values(response.errors).flat())] : [];

  if (validation.length > 0) {
    return validation;
  }

  const single = firstApiError(response);

  return single ? [single] : [];
}

export function errorCode(response) {
  return response?.error_code ?? null;
}
